import { APP_INITIALIZER, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { CommonComponentsModule } from 'src/app/common-components/common-components.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { SettingsModule } from './core/settings/settings.module'
import { ConfigurationOptionModule } from './features/configuration-option/configuration-option.module'
import { RaffleLotModule } from './features/raffle/raffle-lot/raffle-lot.module'
import { LayoutModule } from './layout/layout.module'
import { MenuModule } from './menu/menu.module'
import { SharedModule } from './shared/shared.module'
import { registerLocaleData } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import de from '@angular/common/locales/de'
import en from '@angular/common/locales/en'
import fr from '@angular/common/locales/fr'
import localNl from '@angular/common/locales/nl'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { en_US, NZ_DATE_CONFIG, NZ_I18N } from 'ng-zorro-antd/i18n'
import { environment } from 'src/environments/environment'
import { BookingModule } from './features/booking/booking.module'
import { EmailLogModule } from './features/email-log/email-log.module'
import { GateModule } from './features/gate/gate.module'
import { MetaOptionModule } from './features/meta-option/meta-option.module'
import { OrganizationModule } from './features/organization/organization.module'
import { ProductModule } from './features/product/product.module'
import { RentalModule } from './features/rental/rental.module'
import { RolePermissionsModule } from './features/role-permissions/role-permissions.module'
import { SubscriptionLinkedSubscriptionsModule } from './features/subscription-linked-subscriptions/subscription-linked-subscriptions.module'
import { VisitModule } from './features/visit/visit.module'
import { MessageModule } from './features/message/message.module'
import { TranslateService } from '@ngx-translate/core'
import { DynamicContentItemModule } from './features/overview/dynamic-content-item/dynamic-content-item.module'

registerLocaleData(localNl)
registerLocaleData(en)
registerLocaleData(de)
registerLocaleData(fr)

//Initialize translation service
export function setupTranslateFactory(translate: TranslateService) {
  return () => {
    translate.addLangs(environment.availableLanguageCodes)
    translate.setDefaultLang(environment.defaultLanguage)
    return translate.use(environment.defaultLanguage).toPromise()
  }
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [AppRoutingModule, // must be before other modules with routes
        BrowserModule,
        CoreModule,
        LayoutModule,
        MenuModule,
        SettingsModule,
        SharedModule,
        ConfigurationOptionModule,
        OrganizationModule,
        ProductModule,
        CommonComponentsModule,
        BookingModule,
        EmailLogModule,
        FormsModule,
        RolePermissionsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        RaffleLotModule,
        RentalModule,
        GateModule,
        VisitModule,
        SubscriptionLinkedSubscriptionsModule,
        MetaOptionModule,
        SubscriptionLinkedSubscriptionsModule,
        MessageModule,
        DynamicContentItemModule], providers: [
        {
            provide: APP_INITIALIZER, // to ensure that translations are loaded when the app starts
            useFactory: setupTranslateFactory,
            deps: [TranslateService],
            multi: true
        },
        { provide: NZ_I18N, useValue: en_US },
        {
            provide: NZ_DATE_CONFIG,
            useValue: {
                firstDayOfWeek: 1 // week starts on Monday (Sunday is 0)
            }
        },
        AppComponent,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
